import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=755e7036&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755e7036",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('755e7036')) {
      api.createRecord('755e7036', component.options)
    } else {
      api.reload('755e7036', component.options)
    }
    module.hot.accept("./Test.vue?vue&type=template&id=755e7036&scoped=true", function () {
      api.rerender('755e7036', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/Test.vue"
export default component.exports